// Lodash
import _property from "lodash/property";

const id = _property("_id");
const isActive = _property("is_active");
const userName = _property("username");
const createdAt = _property("createdAt");
const email = _property("email");
const emailVerified = _property("email_verified");
const fullName = _property("fullname");
const firstName = _property("firstName");
const lastName = _property("lastName");
const gender = _property("gender");
const profileImageUrl = _property("profile_pic");
const contactNumber = _property("contact_no");
const dateOfBirth = _property("dob");
const role = _property("role");
const comapnyName = _property("comapny_id.name");
const comapnyId = _property("comapny_id._id");
const bussiness_id = _property("bussiness._id");
const activityPercentage = _property("bussiness.activity_percentage");
const packagePercentage = _property("bussiness.package_percentage");
const slotPercentage = _property("bussiness.slot_percentage");
const postsCount = _property("postsCount");
const eventsCount = _property("eventsCount");
const eventsJoinCount = _property("eventsJoinCount");
const isDelete = _property("is_delete");
const appVersionAndroid = _property("appVersion.version_android");
const appVersionIOS = _property("appVersion.version_ios");
const lastOpen = _property("lastOpen");
const favorite_sports = _property("favorite_sports");
const firstVersion = _property("firstVersion");
const friends = _property("friends");
const blocked = _property("blocked");

export default {
  id,
  isActive,
  userName,
  createdAt,
  email,
  emailVerified,
  fullName,
  firstName,
  lastName,
  gender,
  role,
  comapnyName,
  comapnyId,
  profileImageUrl,
  contactNumber,
  dateOfBirth,
  packagePercentage,
  slotPercentage,
  activityPercentage,
  postsCount,
  eventsCount,
  eventsJoinCount,
  isDelete,
  appVersionAndroid,
  appVersionIOS,
  lastOpen,
  favorite_sports,
  bussiness_id,
  firstVersion,
  friends,
  blocked,
};
